import { render, staticRenderFns } from "./three-d.vue?vue&type=template&id=bb086032&scoped=true"
import script from "./three-d.vue?vue&type=script&lang=js"
export * from "./three-d.vue?vue&type=script&lang=js"
import style0 from "./three-d.vue?vue&type=style&index=0&id=bb086032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb086032",
  null
  
)

export default component.exports